import { defineMessages } from 'react-intl-next';

export default defineMessages({
	reorderingMenuTriggerLabel: {
		id: 'navigation.global-side-navigation.nav-item.actions.reordering.trigger-label',
		defaultMessage: 'Reorder menu item',
		description: 'Label for the button that opens the sub-menu for actions to reorder the menu',
	},
	moveToTop: {
		id: 'navigation.global-side-navigation.nav-item.actions.reordering.move-to-top',
		defaultMessage: 'Move to top',
		description: 'Label for the actions menu item to move the item to the top of the menu',
	},
	moveUp: {
		id: 'navigation.global-side-navigation.nav-item.actions.reordering.move-up',
		defaultMessage: 'Move up',
		description: 'Label for the actions menu item to move the item up one position in the menu',
	},
	moveDown: {
		id: 'navigation.global-side-navigation.nav-item.actions.reordering.move-down',
		defaultMessage: 'Move down',
		description: 'Label for the actions menu item to move the item down one position in the menu',
	},
	moveToBottom: {
		id: 'navigation.global-side-navigation.nav-item.actions.reordering.move-to-bottom',
		defaultMessage: 'Move to bottom',
		description: 'Label for the actions menu item to move the item to the bottom of the menu',
	},
});
